import session from "../../../util/session";
import util from "../../../util/util";
import profiles from "../../../util/profiles";
import encryptUtil from "../../../util/encryptUtil";

/**
 * retorna o caminho da foto de perfil do usuario
 * @param {*} user
 */
export function getUserPhoto(user) {
  if (user.worker && user.worker.file) return user.worker.file;
  if (user.photo) return user.photo;
  return null;
}

export function buildUserConfigs(loginModel) {
  const userConfigs = {
    id: loginModel.id,
    name: loginModel.givenName,
    givenName: loginModel.givenName,
    familyName: loginModel.familyName,
    email: loginModel.username,
    profile: loginModel.accessLevel,
    status: loginModel.status,
    showPrivacy: loginModel.showPrivacy,
    privacy: loginModel.privacy,
    loginSso: loginModel.login_sso,
    smartBadge: loginModel.smartBadge,
    hasAccessToRDO: loginModel.has_access_to_rdo,
    hasAccessToPunchList: loginModel.has_access_to_punchlist,
  };
  if (loginModel.clientId) {
    userConfigs.client = loginModel.clientId;
  }
  userConfigs.aiEvaluationModule = !!(loginModel.client && loginModel.client.aiEvaluationModule);

  if (loginModel.companieId) {
    userConfigs.companie = loginModel.companieId;
    userConfigs.companieName = loginModel.companie.name;
  }

  if (loginModel.contractedId) {
    // userConfigs.contracted = loginModel.contractedId;
    if (
      loginModel.contracted &&
      (loginModel.contracted.type === util.TYPE_CONTRACTED_CONTRACTED ||
        loginModel.contracted.type === null)
    ) {
      userConfigs.contractedId = loginModel.contracted.id;
      userConfigs.companieName = loginModel.companie.name;
    }
    if (
      loginModel.contracted &&
      loginModel.contracted.contractedId &&
      loginModel.contracted.type === util.TYPE_CONTRACTED_SUBCONTRACTED
    ) {
      userConfigs.contractedId = loginModel.contracted.contractedId;
      userConfigs.subContractedId = loginModel.contracted.id;
    }
    if (
      loginModel.contracted &&
      loginModel.contracted.contractedId &&
      loginModel.contracted.subContracted &&
      loginModel.contracted.type === util.TYPE_CONTRACTED_SUBSUBCONTRACTED
    ) {
      userConfigs.contractedId =
        loginModel.contracted.subContracted.contractedId;
      userConfigs.subContractedId = loginModel.contracted.contractedId;
      userConfigs.subSubContractedId = loginModel.contracted.id;
    }
    // userConfigs.subSubContracted = loginModel.contracted && loginModel.contracted.contractedId && loginModel.contracted.subContracted ? loginModel.contracted.subContracted.contractedId : null;
    // userConfigs.contractedId = loginModel.contracted ? loginModel.contracted.contractedId : null;
    userConfigs.contracted = loginModel.contracted
      ? loginModel.contracted
      : null;
  }

  if (loginModel.subContractedId) {
    userConfigs.subContracted = loginModel.subContractedId;
  }
  if (loginModel.status) {
    userConfigs.status = loginModel.status;
  }

  if (loginModel.workerId) {
    userConfigs.worker = loginModel.workerId;
  }
  userConfigs.userFile = getUserPhoto(loginModel);

  return userConfigs;
}

/**
 * Grava a sessão exatamente como o Login.js fazia em `persistValues`:
 * cria o session token, grava `token`, `ttv` (cifrado) e `userConfig`
 * (cifrado, JSON.stringify) no sessionStorage. Grava `userKey` apenas se
 * informado — o login tradicional já grava essa chave separadamente, logo
 * após a resposta do backend, então não passa esse argumento.
 * Não toca em localStorage: "manter conectado" continua sendo
 * responsabilidade exclusiva do Login.js, e o SSO nunca salva credencial.
 */
export function persistSession(token, userConfigs, userKey) {
  // A chave precisa existir no sessionStorage ANTES de qualquer chamada a
  // encryptUtil.encrypt/decrypt, pois esse util sempre lê "userKey" do
  // sessionStorage internamente (ignora qualquer argumento). No fluxo SSO
  // não existe userKey previamente gravado (aba nova), então se este bloco
  // rodar depois dos encrypt() abaixo, "ttv" e "userConfig" são gravados
  // como string vazia e a sessão fica ilegível. Não reordene isto.
  if (userKey) {
    sessionStorage.setItem("userKey", userKey);
  }
  session.createSessionToken();
  sessionStorage.setItem("token", token);
  sessionStorage.setItem(
    "ttv",
    encryptUtil.encrypt(new Date().getTime().toString())
  );
  sessionStorage.setItem(
    "userConfig",
    encryptUtil.encrypt(JSON.stringify(userConfigs))
  );
}

export function routeForProfile(userConfigs) {
  if (
    profiles.isProfileContracted(+userConfigs.profile) ||
    profiles.isProfileSubContracted(+userConfigs.profile)
  ) {
    return profiles.isProfilesActivesContracteds(+userConfigs.profile)
      ? "/Actives/report"
      : "/Workers/report";
  }
  if (+userConfigs.profile === +profiles.PROFILE_WORKER) {
    return {
      pathname: "pessoas/informacoes",
      query: { worker: userConfigs.worker },
    };
  }
  return "/dashboard";
}
